export const detectProfileIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    // Open profile page
    if (cleaned.includes("open profile") || cleaned.includes("my profile")) {
        return { intent: "open_profile" };
    }

    // Update name
    if (cleaned.includes("change my name") || cleaned.includes("update my name")) {
        return { intent: "update_name" };
    }

    // Update mobile
    if (cleaned.includes("change my mobile") || cleaned.includes("update my phone")) {
        return { intent: "update_mobile" };
    }

    // Update profile photo
    if (cleaned.includes("change my photo") || cleaned.includes("update my photo") || cleaned.includes("change my profile picture")) {
        return { intent: "update_photo" };
    }

    return null;
};
